"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoAIAgentPresenter = void 0;
const autoAIAgent_1 = require("../view/components/autoAIAgent/autoAIAgent");
class AutoAIAgentPresenter {
    viewModel;
    setViewModel(viewModel) {
        this.viewModel = viewModel;
    }
    open() {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.screen = autoAIAgent_1.AutoAIAgentScreen.SELECTOR;
        this.viewModel.currentAgent = undefined;
        this.viewModel.isVisible = true;
    }
    close() {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.isVisible = false;
    }
    showSelector() {
        if (this.viewModel) {
            this.viewModel.currentAgent = undefined;
        }
        this.setScreen(autoAIAgent_1.AutoAIAgentScreen.SELECTOR);
    }
    showChat() {
        this.setScreen(autoAIAgent_1.AutoAIAgentScreen.CHAT);
    }
    selectAgent(agent) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.currentAgent = agent;
        this.showChat();
    }
    setAgents(agents) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.agents = agents;
        this.viewModel.hasLoadedAgents = true;
    }
    addAgent(agent) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.agents = [agent, ...this.viewModel.agents];
    }
    updateAgentName(agentId, name) {
        const agent = this.viewModel?.agents.find(({ ID }) => ID === agentId);
        if (!agent) {
            return;
        }
        agent.Name = name;
        if (this.viewModel?.currentAgent?.ID === agentId) {
            this.viewModel.currentAgent.Name = name;
        }
    }
    getNextAgentName() {
        const prefix = 'シフトエージェント';
        const highestAgentNumber = (this.viewModel?.agents ?? []).reduce((highest, agent) => {
            const match = agent.Name.match(/^シフトエージェント(\d+)$/);
            return match ? Math.max(highest, Number(match[1])) : highest;
        }, 0);
        return `${prefix}${highestAgentNumber + 1}`;
    }
    setScreen(screen) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.screen = screen;
    }
}
exports.AutoAIAgentPresenter = AutoAIAgentPresenter;
